<script setup lang="ts">
/**
 * This component renders a dropdown menu container, just the outermost decoration
 * for the menu. There is a hack for chrome based browsers since they don't allow
 * nested filters that the filter is placed on a ::before item to not cause nesting
 * optimizations.
 */
const container = useTemplateRef("container")
const { previewNoFade, navIgnoreMainViewGestures } = useGlobals()
const { shouldNavElementsBeHidden } = usePreview()

defineExpose({ container })
</script>

<template>
  <div
    ref="container"
    class="dropdown-container"
    :class="{
      [previewNoFade]: true,
      [navIgnoreMainViewGestures]: true,
      'fade-out': shouldNavElementsBeHidden,
    }"
  >
    <div class="dropdown">
      <slot />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.dropdown-container
  @apply relative max-h-full min-h-0 flex flex-col
  opacity: 1
  transition: opacity 0.35s ease-in-out
  &.fade-out
    opacity: 0.0
.dropdown
  @apply parent-menu-dropdown-container overflow-auto
  &::before
    @apply parent-menu-dropdown-blur border-[#{$menu-b-outline}] border-1.4
</style>
